import {field} from '../field'
import {mergeConfig} from '../../configStore'
import type {NumberField, FieldReturn} from '../../types'

export const number = (props?: NumberField, mergeProps?: Partial<NumberField>): FieldReturn =>
  field('number', mergeConfig('number', props, mergeProps))
